import request from '@/utils/request'

//获取验证码
export function gainCode(params){
    return request({
        url:`/sendEmail?${params}`,
        method:'get',
    })
}

//验证验证码
export function Proving(params){
    return request({
        url:"/checkEmailCode",
        method:'get',
        params:params
    })
}